import React from 'react'
import ComparisonBarGraph from './ComparisonBarGraph'
import ComparisonBarGraphStyled from './ComparisonBarGraphStyled'
import {
  type ComparisonBarGraphVariant,
  THEME_REGULAR_VS_DIRECT_RETURNS,
} from './comparisonBarGraphThemes'

interface ComparisonBarGraphWrapperProps {
  regularValue: number
  directValue: number
  variant?: ComparisonBarGraphVariant
  /** For regularVsDirectReturns: 'sqrt' compresses the visual height difference between the two bars. */
  scaleType?: 'linear' | 'sqrt'
}

/**
 * Wrapper that renders the comparison bar graph with optional variant.
 * - default: original ComparisonBarGraph (blue/orange, solid bars, radius 4).
 * - regularVsDirectReturns: styled bars with rounded tops, custom colors and diagonal stripes.
 */
const ComparisonBarGraphWrapper: React.FC<ComparisonBarGraphWrapperProps> = ({
  regularValue,
  directValue,
  variant = 'default',
  scaleType = 'linear',
}) => {
  if (variant === 'regularVsDirectReturns') {
    return (
      <ComparisonBarGraphStyled
        regularValue={regularValue}
        directValue={directValue}
        theme={THEME_REGULAR_VS_DIRECT_RETURNS}
        scaleType={scaleType === 'linear' ? 'sqrt' : scaleType}
      />
    )
  }

  return (
    <ComparisonBarGraph
      regularValue={regularValue}
      directValue={directValue}
    />
  )
}

export default ComparisonBarGraphWrapper
export type { ComparisonBarGraphVariant }
